import React from 'react';
import { useTranslation } from 'react-i18next';

import Icon from './Icon';

const URL = 'https://help.eleveo.com/display/WFM/';

export const DocLink: React.FC = () => {
  const { t } = useTranslation();

  return (
    <a className="doclink" data-test-id="link-to-wfm-doc" href={URL} target="_blank" rel="noopener noreferrer">
      <Icon kind="documentation" size={20} className="mr-2" />
      <span className="pr-2">{t('layout.goToDocumentation')}</span>
    </a>
  );
};
